<template>
  <div
    style="justify-content: center"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div>
      <el-row :gutter="0">
        <el-col :span="24">
          <el-row
            :gutter="0"
            class="eltable row"
            style="display:flex;flex-wrap: wrap;margin-top:0px;"
          >
            <el-col :span="24">
              <div class="gridContent bggray2 fb tc">《普通高等学校录取新生名册》查询复印服务详情</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">姓名</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ info.name }}</div>
            </el-col>

            <el-col :span="4">
              <div class="gridContent bggray2 tc">身份证号</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ info.idcode }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">手机号</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ info.studenttelephone }}</div>
            </el-col>
            <!-- <el-col :span="4">
              <div class="gridContent bggray2 tc">申请日期</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ dateFormat(info.applicationtime) }}</div>
            </el-col>-->
            <el-col :span="4">
              <div class="gridContent bggray2 tc">新生名册类型</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ rosterTypeLabel}}</div>
            </el-col>
            <template v-if="info.rostertype=='02'?true:false">
              <el-col :span="4">
                <div class="gridContent bggray2 tc">专升本考试年份</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.zsbyear }}</div>
              </el-col>
            </template>
            <template v-if="info.rostertype=='03'?true:false">
              <el-col :span="4">
                <div class="gridContent bggray2 tc">高职扩招考试年份</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.gzkzyear }}</div>
              </el-col>
            </template>
            <template v-if="info.rostertype=='01'?true:false">
              <el-col :span="4">
                <div class="gridContent bggray2 tc">参加高考年份</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.gkyear }}</div>
              </el-col>
              <el-col :span="4">
                <div class="gridContent bggray2 tc">高考所在省份</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.province }}</div>
              </el-col>
              <el-col :span="4">
                <div class="gridContent bggray2 tc">高中科目类型</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ subjectTypeLabel }}</div>
              </el-col>
              <el-col :span="4">
                <div class="gridContent bggray2 tc">录取批次</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ admissionBatchLabel }}</div>
              </el-col>
            </template>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">录取专业</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ info.major }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">个人邮箱</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ info.email }}</div>
            </el-col>
            <el-col :span="4">
              <div class="gridContent bggray2 tc">领取方式</div>
            </el-col>
            <el-col :span="8">
              <div class="gridContent">{{ receiveMethodLabel }}</div>
            </el-col>

            <template v-if="info.receivemethod=='02'?true:false">
              <el-col :span="4">
                <div class="gridContent bggray2 tc">受托人姓名</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.trusteename }}</div>
              </el-col>
              <el-col :span="4">
                <div class="gridContent bggray2 tc">受托人身份证号</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.trusteeidcode }}</div>
              </el-col>
              <el-col :span="4">
                <div class="gridContent bggray2 tc">受托人手机号码</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.trusteetelephone }}</div>
              </el-col>
            </template>

            <template v-if="info.receivemethod=='03'?true:false">
              <el-col :span="4">
                <div class="gridContent bggray2 tc">收件人姓名</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.recipientname }}</div>
              </el-col>
              <el-col :span="4">
                <div class="gridContent bggray2 tc">收件人手机号</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.recipienttelephone }}</div>
              </el-col>
              <el-col :span="4">
                <div class="gridContent bggray2 tc">收件详细地址</div>
              </el-col>
              <el-col :span="8">
                <div class="gridContent">{{ info.recipientadress }}</div>
              </el-col>
            </template>
          </el-row>
          <el-row
            :gutter="0"
            class="eltable row"
            style="display:flex;flex-wrap: wrap;margin-top:-2px;border-top: 1px solid #ddd;"
          >
            <el-col :span="4">
              <div
                class="gridContent bggray2"
                style="
                display: flex;
                align-items: center;
                justify-content: center;
                height: 119px;
              "
              >备注说明</div>
            </el-col>
            <el-col :span="20">
              <div class="gridContent" style="height: 119px;">{{ info.memo }}</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
  
<script>
import "@/static/css/my.css";
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import moment from "moment";
import {
  findCopyServiceInfoById,
  getSysDict
} from "@/api/admissionRosterCopy.js";

export default {
  name: "admissionRosterCopyDetaileIframe",
  data() {
    return {
      user: {},
      info: {},
      //id: "e015456ccbeb4248a5c8873e566f4b44", //a473f45f069d4b34bebf4f9c07d7d3c8,e015456ccbeb4248a5c8873e566f4b44
      id: "",
      url: "",
      xzztcToken: "",
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      playStatus: "",
      muteStatus: "",
      isMute: true,
      isPlay: false,
      autoplay: "",
      srcList: [],
      contentHeight: 0,
      heightDiv: 0,
      loading: true,
      subjectTypeLabel: "",
      receiveMethodLabel: "",
      admissionBatchLabel: "",
      rosterTypeLabel: ""
    };
  },
  computed: {},
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem("userInfo"));
    console.log(this.user.userid);
    this.id = this.$route.query.id;
    this.findCopyServiceInfo();
    this.getHeight();
    // this.getDept();
  },
  methods: {
    async findCopyServiceInfo() {
      let data = await findCopyServiceInfoById(this.id);
      this.info = data.data;
      this.getDept();
      this.loading = false;
    },

    getHeight() {
      this.$nextTick(function() {
        this.contentHeight = document.getElementsByClassName(
          "row"
        )[0].clientHeight;
        this.heightDiv = this.contentHeight - 60 + "px";
        this.contentHeight = this.contentHeight + "px";
        console.log(this.contentHeight, this.heightDiv); //元素高度
      });
    },
    dateFormat(date) {
      if (date != null && date != "") {
        return moment(date).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    getDept() {
      getSysDict("RECEIVE_METHOD").then(res => {
        if (res.data !== null) {
          res.data.map(item => {
            if (this.info.receivemethod == item.dictcode) {
              this.receiveMethodLabel = item.dictname;
            }
          });
        }
      });
      getSysDict("ADMISSION_BATCH").then(res => {
        if (res.data !== null) {
          res.data.map(item => {
            if (this.info.admissionbatch == item.dictcode) {
              this.admissionBatchLabel = item.dictname;
            }
          });
        }
      });
      getSysDict("SUBJECT_TYPE").then(res => {
        if (res.data !== null) {
          res.data.map(item => {
            if (this.info.subjecttype == item.dictcode) {
              this.subjectTypeLabel = item.dictname;
            }
          });
        }
      });
      getSysDict("ROSTER_TYPE").then(res => {
        if (res.data !== null) {
          res.data.map(item => {
            if (this.info.rostertype == item.dictcode) {
              this.rosterTypeLabel = item.dictname;
            }
          });
        }
      });
    },
    goBack() {
      this.$router.push("/userCenter");
    }
  }
};
</script>
<style scoped>
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  border-left: 1px solid #ddd;
  margin-top: 20px;
  border-top: 1px solid #ddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
}

.rightTable {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}

.rightDiv {
  padding-top: 10px;
  margin-left: 10%;
  padding-left: 5px;
  overflow-y: scroll;
}

.el-rate__icon {
  font-size: 28px;
}

.bggray2 {
  background-color: #e2f3cf;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
  margin-right: 10px;
}

.avatar {
  width: 160px;
  height: 160px;
  float: left;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin-right: 10px;
  line-height: 88px;
  text-align: center;
  /* display: block;  */
}

>>> .el-image__error,
>>> .el-image__inner,
>>> .el-image__placeholder {
  width: 160px;
  height: 160px;
}

>>> .el-step__title.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

>>> .el-step__head.is-finish {
  color: #008a2c;
  border-color: #008a2c;
  font-size: 14px;
  text-align: center;
  /* justify-content: center; */
}

>>> .el-step__description.is-finish {
  color: rgb(17, 1, 69);
  font-size: 14px;
  /* text-align: center; */
}

::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.1);
}

.btn1.el-button {
  background-color: #008a2c;
  color: white;
}

.btn1.el-button:hover {
  color: white;
  border-color: #e0fae8;
  background-color: #008a2cc9;
}
</style>